<template>
    <div>
        <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
        >
        </TopAppBar>
        <div class="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust">
            <div class="mdc-layout-grid">
                <div class="mdc-layout-grid__inner">
                    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
                        <!-- <div class="mdc-typography--headline4 ">
                            Mobile Home
                        </div> -->
                        <div class="mdc-typography--subtitle1 ">
                            Menu that requires login
                        </div>
                        <div>
                            <ul class="mdc-list demo-list">
                                <li class="mdc-list-divider" role="separator"></li>
                                <router-link class="mdc-list-item mdc-ripple-upgraded" tag="li" to="/learn?status=LEARNING">
                                    <span class="mdc-list-item__graphic material-icons" aria-hidden="true">inbox</span>
                                    {{$t('250')}}
                                    <!-- 수강중인 과정 -->
                                </router-link>
                                <router-link class="mdc-list-item mdc-ripple-upgraded" tag="li" to="/certification">
                                    <span class="mdc-list-item__graphic material-icons" aria-hidden="true">inbox</span>
                                    {{$t('251')}}
                                    <!-- 증명서 -->
                                </router-link>
                                <li class="mdc-list-divider" role="separator"></li>
                                <router-link class="mdc-list-item mdc-ripple-upgraded" tag="li" to="/independent/exam">
                                    <span class="mdc-list-item__graphic material-icons" aria-hidden="true">inbox</span>
                                    {{$t('104')}}
                                    <!-- 시험지 -->
                                </router-link>
                                <router-link class="mdc-list-item mdc-ripple-upgraded" tag="li" to="/independent/survey">
                                    <span class="mdc-list-item__graphic material-icons" aria-hidden="true">inbox</span>
                                    {{$t('106')}}
                                    <!-- 서베이 -->
                                </router-link>
                                <li class="mdc-list-divider" role="separator"></li>
                                <router-link class="mdc-list-item mdc-ripple-upgraded" tag="li" to="/member/profilePatten">
                                    <span class="mdc-list-item__graphic material-icons" aria-hidden="true">inbox</span>
                                    {{$t('255')}}
                                    <!-- 개인정보 -->
                                </router-link>
                                <li class="mdc-list-divider" role="separator"></li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>

            <div class="mdc-layout-grid">
                <div class="mdc-layout-grid__inner">
                    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
                        <div class="mdc-typography--subtitle1 ">
                            Menu that does not require login
                        </div>
                        <div>
                            <ul class="mdc-list demo-list">
                                <li class="mdc-list-divider" role="separator"></li>
                                <router-link class="mdc-list-item mdc-ripple-upgraded" tag="li" to="/degree?type=ListTotal">
                                    <span class="mdc-list-item__graphic material-icons" aria-hidden="true">inbox</span>
                                    {{$t('229')}}
                                    <!-- 추천 강의 -->
                                </router-link>
                                <router-link class="mdc-list-item mdc-ripple-upgraded" tag="li" to="/degree?type=ListPopular">
                                    <span class="mdc-list-item__graphic material-icons" aria-hidden="true">inbox</span>
                                    {{$t('230')}}
                                    <!-- 인기 강의 -->
                                </router-link>
                                <router-link class="mdc-list-item mdc-ripple-upgraded" tag="li" to="/degree?type=ListNew">
                                    <span class="mdc-list-item__graphic material-icons" aria-hidden="true">inbox</span>
                                    {{$t('231')}}
                                    <!-- 신규 강의 -->
                                </router-link>
                                
                                <li class="mdc-list-divider" role="separator"></li>
                                <router-link class="mdc-list-item mdc-ripple-upgraded" tag="li" to="/login">
                                    <span class="mdc-list-item__graphic material-icons" aria-hidden="true">inbox</span>
                                    {{$t('233')}}
                                    <!-- 로그인 -->
                                </router-link>
                                <router-link class="mdc-list-item mdc-ripple-upgraded" tag="li" to="/join2/intro">
                                    <span class="mdc-list-item__graphic material-icons" aria-hidden="true">inbox</span>
                                    {{$t('234')}}
                                    <!-- 회원가입 -->
                                </router-link>
                                <li class="mdc-list-divider" role="separator"></li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 홈 메인 컴포넌트(home main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'
export default {
    name: 'home',
    data() {
        return {
        }
    },
    components: {
        TopAppBar,
    },

    mixins: [topAppBarMixin],

    mounted() {
        this.setTopAppBarHomeBlank()
        
    }
}
</script>
